/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Auth_Signout_Confirm_BodyInputs */

const en_us2_auth_signout_confirm_body = /** @type {(inputs: Auth_Signout_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 workout entry hasn't reached the server yet. If you sign out now, it's lost.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 workout entry hasn't reached the server yet. If you sign out now, it's lost.`);
	return /** @type {LocalizedString} */ (`${i?.count} workout entries haven't reached the server yet. If you sign out now, they're lost.`)
	
};

const pt_br2_auth_signout_confirm_body = /** @type {(inputs: Auth_Signout_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registro do treino ainda não chegou ao servidor. Se você sair agora, ele se perde.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 registro do treino ainda não chegou ao servidor. Se você sair agora, ele se perde.`);
	return /** @type {LocalizedString} */ (`${i?.count} registros do treino ainda não chegaram ao servidor. Se você sair agora, eles se perdem.`)
	
};

const es_419_auth_signout_confirm_body = /** @type {(inputs: Auth_Signout_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registro del entrenamiento todavía no llegó al servidor. Si cierras sesión ahora, se pierde.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 registro del entrenamiento todavía no llegó al servidor. Si cierras sesión ahora, se pierde.`);
	return /** @type {LocalizedString} */ (`${i?.count} registros del entrenamiento todavía no llegaron al servidor. Si cierras sesión ahora, se pierden.`)
	
};

const pt_pt2_auth_signout_confirm_body = /** @type {(inputs: Auth_Signout_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registo do treino ainda não chegou ao servidor. Se saíres agora, perde-se.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 registo do treino ainda não chegou ao servidor. Se saíres agora, perde-se.`);
	return /** @type {LocalizedString} */ (`${i?.count} registos do treino ainda não chegaram ao servidor. Se saíres agora, perdem-se.`)
	
};

const fr_fr2_auth_signout_confirm_body = /** @type {(inputs: Auth_Signout_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 entrée de séance n'a pas encore atteint le serveur. Si tu te déconnectes maintenant, elle sera perdue.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 entrée de séance n'a pas encore atteint le serveur. Si tu te déconnectes maintenant, elle sera perdue.`);
	return /** @type {LocalizedString} */ (`${i?.count} entrées de séance n'ont pas encore atteint le serveur. Si tu te déconnectes maintenant, elles seront perdues.`)
	
};

const de_de2_auth_signout_confirm_body = /** @type {(inputs: Auth_Signout_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Trainingseintrag ist noch nicht beim Server angekommen. Wenn du dich jetzt abmeldest, geht er verloren.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Trainingseintrag ist noch nicht beim Server angekommen. Wenn du dich jetzt abmeldest, geht er verloren.`);
	return /** @type {LocalizedString} */ (`${i?.count} Trainingseinträge sind noch nicht beim Server angekommen. Wenn du dich jetzt abmeldest, gehen sie verloren.`)
	
};

const it_it2_auth_signout_confirm_body = /** @type {(inputs: Auth_Signout_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registrazione dell'allenamento non è ancora arrivata al server. Se esci ora, andrà persa.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 registrazione dell'allenamento non è ancora arrivata al server. Se esci ora, andrà persa.`);
	return /** @type {LocalizedString} */ (`${i?.count} registrazioni dell'allenamento non sono ancora arrivate al server. Se esci ora, andranno perse.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 workout entry hasn't reached the server yet. If you sign out now, it's lost." |
* | "-1" | "1 workout entry hasn't reached the server yet. If you sign out now, it's lost." |
* | * | "{count} workout entries haven't reached the server yet. If you sign out now, they're lost." |
*
* @param {Auth_Signout_Confirm_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_signout_confirm_body = /** @type {((inputs: Auth_Signout_Confirm_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signout_Confirm_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_signout_confirm_body(inputs)
	if (locale === "es-419") return es_419_auth_signout_confirm_body(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_signout_confirm_body(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_signout_confirm_body(inputs)
	if (locale === "de-DE") return de_de2_auth_signout_confirm_body(inputs)
	if (locale === "it-IT") return it_it2_auth_signout_confirm_body(inputs)
	return en_us2_auth_signout_confirm_body(inputs)
});
export { auth_signout_confirm_body as "auth.signout_confirm_body" }